import { UsdaGrowerDetailsTaskEditor } from './UsdaGrowerDetailsTaskEditor'

export const UsdaGrowerDetailsFeatureMap = {
  Component: {
    traitId: 'usdaGrowerDetails' as const,
    TaskEditor: UsdaGrowerDetailsTaskEditor,
  },
  resourceType: 'user' as const,
}
